import { jsonldRecipeCuisine } from './JsonldStore';

export const updateJsonldRecipeCuisine = (value) => jsonldRecipeCuisine.update((oldValue) => value);
